export type Collection<T> = {
  collection: T[]
}

const load = <T = unknown>(model?: Collection<T> | undefined): Collection<T> => {
  return {
    collection: model?.collection ?? [],
  }
}

const map = <T = unknown, K = unknown>({
  data,
  func,
}: {
  data: Collection<T>
  func: (i: T) => K
}): K[] => data.collection.map((i) => func(i))

export const Collection = {
  load,
  map,
}
